import React from 'react';
import styled from 'styled-components';
import { margin, MarginProps } from 'styled-system';

import { Typography } from '../typography';
import WarningIcon from '../assets/warning-icon';

type ConnectionWarningProps = MarginProps;

export const ConnectionWarning = (props: ConnectionWarningProps): JSX.Element => (
  <WarningContainer {...props}>
    <WarningIcon /> <Typography.Body size='small'>Slow network connection detected</Typography.Body>
  </WarningContainer>
);

const WarningContainer = styled.div<MarginProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.colors.primaryOrange};
  ${margin}
`;
